module.exports = __webpack_public_path__ + "static/img/18091014.cb603e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/180910/18091014.jpg
// module id = G1j8
// module chunks = 0